import API from '../../helpers/interceptor';

// ── Delivery / IOD Update ─────────────────────────────────────────────────────

export const listPendingInvoices = (params = {}) =>
  API.post('/v1/invoices/delivery/pending', params);

export const updateIod = (payload) =>
  API.post('/v1/invoices/delivery/update', payload);

export const bulkUpdateIod = (records) =>
  API.post('/v1/invoices/delivery/bulk-update', { records });

export const updateIodByLoad = (payload) =>
  API.post('/v1/invoices/delivery/update-by-load', payload);

export const getDeliveryInfo = (company, transactionType, invoiceNo) =>
  API.post('/v1/invoices/delivery/get', { company, transactionType, invoiceNo });

export const getInvoiceDetail = (company, transactionType, invoiceNo) =>
  API.post('/v1/invoices/delivery/detail', { company, transactionType, invoiceNo });

// ── IOD Reverse ───────────────────────────────────────────────────────────────

export const listReversibleInvoices = (params = {}) =>
  API.post('/v1/invoices/delivery/reversible', params);

export const rollbackIod = (company, transactionType, invoiceNo) =>
  API.post('/v1/invoices/delivery/rollback', { company, transactionType, invoiceNo });

// ── Load-based ────────────────────────────────────────────────────────────────

export const listPendingByLoad = (loadNumber, params = {}) =>
  API.post('/v1/invoices/delivery/pending-by-load', { loadNumber, ...params });

// ── Excel Upload ──────────────────────────────────────────────────────────────

export const processExcelUpload = (records) =>
  API.post('/v1/invoices/upload/process', { records });

export const getUploadLog = (fileId, params = {}) =>
  API.post('/v1/invoices/upload/log', { fileId, ...params });

export const getUploadErrors = (fileId) =>
  API.post('/v1/invoices/upload/errors', { fileId });

// ── Control Parameters ────────────────────────────────────────────────────────

export const getControlValue = (parameter) =>
  API.post('/iod/control/get', { parameter });

// ── Freeze ────────────────────────────────────────────────────────────────────

export const getCurrentFreeze = () =>
  API.get('/v1/freeze/current');
